import messages from '../../../../locale/messages';

const validate = values => {
    const errors = {};

    if (!values.title) {
        errors.title = messages.required;
    } else if (values.title && values.title.toString().trim() == '') {
        errors.title = messages.required;
    } else if (values.title.length > 100) {
        errors.title = messages.exceedLimit100
    }

    if (!values.code) {
        errors.code = messages.required;
    } else if (values.code && values.code.toString().trim() == '') {
        errors.code = messages.required;
    } else if (values.code.length > 20) {
        errors.code = messages.exceedLimit10
    }

    if (!values.promoValue) {
        errors.promoValue = messages.required;
    } else if (values.promoValue == 0) {
        errors.promoValue = messages.required;
    } else if (values.promoValue && values.promoValue.toString().trim() == '') {
        errors.promoValue = messages.required;
    } else if (values.promoValue) {
        if (values.type == 2) { // Fixed amount
            if (isNaN(values.promoValue) || (!/^[0-9\.]+$/.test(values.promoValue)) || (parseFloat(values.promoValue, 10) < 0)) {
                errors.promoValue = messages.floatError;
            } else if (values.promoValue.length > 8) {
                errors.promoValue = messages.exceedLimit8;
            }
        } else { // Percentage
            if (isNaN(values.promoValue)) {
                errors.promoValue = messages.floatError;
            } else if (!/^[0-9]+$/.test(values.promoValue)) {
                errors.promoValue = messages.intError;
            } else if (parseInt(values.promoValue, 10) < 0 || parseInt(values.promoValue, 10) > 100) {
                errors.promoValue = messages.percentError;
            }
        }
    }

    if (!values.description) {
        errors.description = messages.required;
    } else if (values.description && values.description.toString().trim() == '') {
        errors.description = messages.required;
    } else if (values.description.length > 1000) {
        errors.description = messages.exceedLimit200
    }

    if (!values.variant) {
        errors.variant = messages.variantRequired;
    }

    if (values.isStockEnabled) {
        if (!values.stock) {
            errors.stock = messages.required;
        } else if (isNaN(values.stock) || parseInt(values.stock, 10) < 0) {
            errors.stock = messages.invalidStock;
        }
    }

    if (values.minOrderValue) {
        if (isNaN(values.minOrderValue) || parseFloat(values.minOrderValue) < 0) {
            errors.minOrderValue = messages.floatError;
        }
    }

    if (!values.isFirstOrderOnly && values.minOrderCount) {
        if (isNaN(values.minOrderCount) || parseInt(values.minOrderCount, 10) < 1) {
            errors.minOrderCount = messages.invalidStock;
        }
    }

    return errors;
};

export default validate